import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IGatewayConfigurationResponse } from '../../../entity/interface/iGatewayConfiguration';
import { IGatewayRepository } from '../../repositories/interfaces/iGatewayRepository';

export interface IGetGatewayConfigurationUseCase {
    execute(endpoint: string, params: string, appkey: string): Promise<IGatewayConfigurationResponse['data']>;
}

export class GetGatewayConfigurationUseCase implements IGetGatewayConfigurationUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get gatewayRepository(): IGatewayRepository {
        return container.resolve<IGatewayRepository>(DI.REPOSITORIES.IGatewayRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(endpoint: string, params: string, appKey: string): Promise<IGatewayConfigurationResponse['data']> {
        const response = await this.gatewayRepository.getGatewayConfiguration(endpoint, params, appKey);
        return response.data;
    }
}
